import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Spin,
  message,
  Radio,
  Space,
  Checkbox,
} from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { RESEARCH_TYPE } from "../../utils/consts";

const { Option } = Select;

export default class ConsentFormChild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      i_accept_checkbox: "",
      permission_to_link_clinical_info: "",
      permission_to_contact_third_parties: "",
      participant_in_familial_als_group_meetings: "",
      electronic_signature_acknowledgment: "",
      full_name: "",
      signature_date: "",
      loading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Consent form signed?") {
                if (item.value == "Yes") {
                  this.setState({ i_accept_checkbox: item.value });
                  this.props.set_active_step(1);
                }
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save_details = () => {
    if (!this.state.i_accept_checkbox) {
      message.warning("Please accept consent form assigned");
      return;
    }
    if (!this.state.full_name) {
      message.warning("Please enter full name");
      return;
    }
    if (!this.state.signature_date) {
      message.warning("Please enter signature date");
      return;
    }
    let questions = [
      {
        parent_field: "Consent form signed?",
        field: "Consent form signed?",
        value: "Yes",
      },
      {
        parent_field: "Acknowledgment Signature Full Name",
        field: "Acknowledgment Signature Full Name",
        value: this.state.full_name,
      },
      {
        parent_field: "Acknowledgment Signature Date",
        field: "Acknowledgment Signature Date",
        value: this.state.signature_date,
      },
      {
        parent_field: "Familial ALS Group Meetings",
        field: "Familial ALS Group Meetings",
        value: this.state.participant_in_familial_als_group_meetings,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "0",
      type: "consent_form",
    };
    this.setState({ loading: true });

    if(RESEARCH_TYPE == 'Asymptomatic Study'){
      Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              this.props.set_active_step(1);
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
    }else if(RESEARCH_TYPE=='ECAS Study'){
      Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              this.props.set_active_step(1);
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
    }else{
      message.warning("Please try again!!");
      return;
    }
    
  };
  logout = () => {
    localStorage.removeItem("ap_eals_id");
    localStorage.clear();
    localStorage.clear();
    window.location.assign("/");
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>CONSENT FORM</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group pdf-div">
              <iframe
                src="./assets/documents/asymptomatic-consent-form.pdf#toolbar=0"
                title="Consent Form"
                width="100%"
                height="600px"
              ></iframe>
            </div>
            <div className="form-group">
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({ i_accept_checkbox: event.target.checked })
                }
                checked={this.state.i_accept_checkbox == true ? true : false}
                style={{ fontSize: 17 }}
              >
                I Accept <span className="text-danger">*</span>
              </Checkbox>
            </div>
            <div className="form-group">
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({
                    permission_to_link_clinical_info: event.target.checked,
                  })
                }
                checked={
                  this.state.permission_to_link_clinical_info == true
                    ? true
                    : false
                }
                style={{ fontSize: 17 }}
              >
                I give permission to link my clinical information from PREVENT
                ALS to my digital data. I understand that means select
                EverythingALS staff will have access to identifiable clinical
                information.  <span className="text-danger">*</span>
              </Checkbox>
            </div>
            <div className="form-group">
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({
                    permission_to_contact_third_parties: event.target.checked,
                  })
                }
                checked={
                  this.state.permission_to_contact_third_parties == true
                    ? true
                    : false
                }
                style={{ fontSize: 17 }}
              >
                I give permission for EverythingALS staff to contact
                third-parties in order to coordinate linking my digital and
                clinical information to biosamples  <span className="text-danger">*</span>
              </Checkbox>
            </div>
            <div className="form-group">
              <label className="input-heading">Check one:  <span className="text-danger">*</span></label>
              <br />
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({
                    participant_in_familial_als_group_meetings:
                      "I would like to participant in Familial ALS group meetings to provide feedback.",
                  })
                }
                checked={
                  this.state.participant_in_familial_als_group_meetings ==
                  "I would like to participant in Familial ALS group meetings to provide feedback."
                    ? true
                    : false
                }
                style={{ fontSize: 17 }}
              >
                I would like to participant in Familial ALS group meetings to
                provide feedback.
              </Checkbox>
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({
                    participant_in_familial_als_group_meetings:
                      "I Do not wish to be invited to the Familial ALS group meetings, and prefer to have one on one sessions.",
                  })
                }
                checked={
                  this.state.participant_in_familial_als_group_meetings ==
                  "I Do not wish to be invited to the Familial ALS group meetings, and prefer to have one on one sessions."
                    ? true
                    : false
                }
                style={{ fontSize: 17 }}
              >
                I Do not wish to be invited to the Familial ALS group meetings,
                and prefer to have one on one sessions.
              </Checkbox>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Electronic Signature Acknowledgment{" "}
                <span className="text-danger">*</span>
              </label>
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({
                    electronic_signature_acknowledgment: event.target.checked,
                  })
                }
                checked={
                  this.state.electronic_signature_acknowledgment == true
                    ? true
                    : false
                }
                style={{ fontSize: 17 }}
              >
                I understand what the study is about, and my questions so far
                have been answered. I agree to take part of this study.
              </Checkbox>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-lg-6">
                  <label className="input-heading">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    placeholder="Full Name"
                    value={this.state.full_name}
                    onChange={(e) =>
                      this.setState({ full_name: e.target.value })
                    }
                    min={0}
                  />
                </div>
                <div className="col-lg-6">
                  <label className="input-heading">
                    Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Date"
                    name="signature_date"
                    value={this.state.signature_date}
                    onChange={(e) =>
                      this.setState({ signature_date: e.target.value })
                    }
                    min={4}
                  />
                </div>
              </div>
            </div>
            {this.state.i_accept_checkbox == true &&
              this.state.permission_to_link_clinical_info == true &&
              this.state.permission_to_contact_third_parties == true &&
              this.state.participant_in_familial_als_group_meetings != "" &&
              this.state.electronic_signature_acknowledgment == true && (
                <button
                  className="submit-button"
                  style={{ padding: "9px 15px 10px 20px" }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              )}
          </div>
        </Spin>
      </div>
    );
  }
}
